import type { IMe } from '@/interface/auth.interface'
import * as React from 'react'

interface UserContextType {
  me: IMe | null
  setMe: (user: IMe | null) => void
}

export const UserContext = React.createContext<UserContextType | undefined>(undefined)
